module.exports = "https://cache-nest.services.handy.com/packs/media/src/assets/images/smart_home-4a4341b02413d41c58464bbbae38cc56.jpg";